import {mapGetters} from 'vuex'
export default{
    computed: {
        ...mapGetters([
            'getTheme', 
            'getApiAdress', 
            'getApiAdd', 
            'getPageSize', 
            'getworkLicence', 
            'getApiKey', 
            'getCombo', 
            'getCheckSize', 
            'getScreenSize',
            'getCompteGL', 
            'getTaxes', 
            'getActiveTaxes', 
            'getAllSize',
            'getTmpClient'
        ]),
    }
}

